import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const product = 'Atlante Visivo di Chinesiologia + 6 bonus';
const notices = [{
  name: 'Camila R.',
  city: 'Guadalajara, Messico',
  product
}, {
  name: 'Nicolás B.',
  city: 'Medellín, Colombia',
  product
}, {
  name: 'Sofía D.',
  city: 'Lima, Perù',
  product
}, {
  name: 'Andrés V.',
  city: 'Santiago, Cile',
  product
}, {
  name: 'Valeria P.',
  city: 'Quito, Ecuador',
  product
}, {
  name: 'Mateo G.',
  city: 'Córdoba, Argentina',
  product
}];
export function PurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const show = window.setTimeout(() => setVisible(true), 6000);
    return () => window.clearTimeout(show);
  }, [dismissed]);
  useEffect(() => {
    if (!visible || dismissed) return;
    const hide = window.setTimeout(() => setVisible(false), 7000);
    const next = window.setTimeout(() => {
      setIndex(current => (current + 1) % notices.length);
      setVisible(true);
    }, 22000);
    return () => {
      window.clearTimeout(hide);
      window.clearTimeout(next);
    };
  }, [visible, index, dismissed]);
  const notice = notices[index];
  return <div className="pointer-events-none fixed bottom-4 left-4 z-40 max-w-[calc(100vw-2rem)]" data-id="element-210" data-mp="285qxd3zlqruw">
      <AnimatePresence data-id="element-211" data-mp="1bhkxsvhjepnh">
        {visible && !dismissed && <motion.aside initial={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} transition={{
        duration: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} aria-live="polite" className="pointer-events-auto flex w-[19rem] items-start gap-3 rounded-2xl bg-white p-4 shadow-lg ring-1 ring-blue-100" data-id="element-212" data-mp="1fh3cvamog6ie">
            <div className="min-w-0 flex-1" data-id="element-213" data-mp="wpj1tmil8gsq">
              <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-widest text-emerald-600" data-id="element-214" data-mp="201rfpi641ke0">
                <span className="h-2 w-2 rounded-full bg-emerald-500" aria-hidden="true" data-id="element-215" data-mp="1v1vc3k1bruyz" />
                Acquisto verificato
              </p>
              <p className="mt-2 text-sm font-bold text-slate-900" data-id="element-216" data-mp="28wfin1o7qpzn">
                {notice.name} da {notice.city}
              </p>
              <p className="truncate text-sm text-blue-900/70" data-id="element-217" data-mp="1h2n9eh5ye4q1">
                Ha acquistato <span className="font-semibold text-blue-700" data-id="element-218" data-mp="1c4280eeytf00">{notice.product}</span>
              </p>
              <p className="mt-1 text-xs text-blue-900/45" data-id="element-219" data-mp="1q3ts8ww2rrmg">2 minuti fa</p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Chiudi avviso" className="rounded-md p-1 text-blue-900/40 transition-colors duration-150 ease-out hover:bg-blue-50 hover:text-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-300" data-id="element-220" data-mp="1q1h3o0vtaj0f">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-221" data-mp="34zcx9uog4mjk" />
            </button>
          </motion.aside>}
      </AnimatePresence>
    </div>;
}